export default __webpack_public_path__ + "static/media/2829 utensils side.225740bf.png";